import { useParams, useNavigate } from "react-router-dom";
import MenuMasterAdd from "./MenuMasterAdd";

export default function MenuEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const items = JSON.parse(localStorage.getItem("menuItems") || "[]");
  const item = items.find((i) => String(i.id) === id);

  if (!item) return <div>Item not found</div>;

  const saveEdit = (updatedItem) => {
    const updated = items.map((i) => (i.id === item.id ? updatedItem : i));
    localStorage.setItem("menuItems", JSON.stringify(updated));
    navigate("/admindashboard/menu-master");
  };

  return <MenuMasterAdd editData={item} onSave={saveEdit} />;
}
